module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-23.153caa12.png";